import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuxiliarService } from 'src/app/_services/auxiliar.service';
import { ViajesService } from 'src/app/_services/viajes.service';
import { ModalConfirmComponent } from '../modal-confirm/modal-confirm.component';
import { ModalMsgComponent } from '../modal-msg/modal-msg.component';

@Component({
  selector: 'app-packs-admin',
  templateUrl: './packs-admin.component.html',
  styleUrls: ['./packs-admin.component.css']
})
export class PacksAdminComponent implements OnInit {
  form: FormGroup;
  listViajes = [];
  cantidad: number;

  constructor(
    private modalService: NgbModal,
    private viajesService:ViajesService,
    private auxService:AuxiliarService,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.cantidad = 0;
    this.form = this.formBuilder.group({
      search: [''],     
    });
    //cargar listado de viajes publicados
    this.viajesPublicados();
  }

  viajesPublicados(){ //devuelve una lista con el id y el mombre de la agencia
    this.listViajes = []; 
    this.viajesService.getViajes('all', this.f.search.value).subscribe(data => {
      if(data instanceof HttpResponse) { 
        this.cantidad = data.body.count;
        this.listViajes = data.body.list;            
      }             
    });       
  }

  get f() { return this.form.controls; }

  onSubmit() { //devuelve una lista con el id y el mombre del viaje segun criterio de búsqueda
    this.viajesPublicados();       

  }

  cancelar(id: string){
    this.viajesService.getCantidadReservacion(id).subscribe(data => {
      if(data instanceof HttpResponse) { 
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones  
        
        if(data.body === 0){
          this.viajesService.deletePaquete(id).subscribe(data => {
            if(data instanceof HttpResponse) { 
              const modalRef = this.modalService.open(ModalMsgComponent, { 
                centered: true,  
                backdrop:'static',      
              });
              modalRef.componentInstance.label = 'Volver'; 
              if(data.body.msg === 'PACK_DELETE_SUCCESS')  {          
                modalRef.componentInstance.titulo = 'Viaje eliminado';
                modalRef.componentInstance.check = 1; 
                this.viajesPublicados(); //segun criterio de busqueda
              } else {
                modalRef.componentInstance.check = 0;    
                modalRef.componentInstance.titulo = 'Ha ocurrido un error';  
              } 
            }
          });
        } else {
          const modalRef = this.modalService.open(ModalConfirmComponent, { 
            centered: true,  
            backdrop:'static',      
          });
          modalRef.componentInstance.id = id;
        }        
      }             
    });   

    
  }

}
